import React from "react"
import Select from "@infotech/uikit-select"
import cn from "classnames"
import isObjectLike from "lodash/isObjectLike"
import { withHandlers } from "recompact"
import "react-select/dist/react-select.css"
import styles from "./styles.css"

function createOptions(options, children) {
  if (isObjectLike(options)) {
    return options
  }
  if (children instanceof Array) {
    return children
      .filter(children => children.props.value)
      .map(children => ({
        label: children.props.children,
        value: children.props.value,
      }))
  }
  return []
}

export default withHandlers({
  onChange: ({ input: { onChange } }) => ({ target: { value } }) => {
    onChange(isObjectLike(value) ? value.value : value)
  },
  onBlur: ({ input: { onBlur, value } }) => () => onBlur(value),
})(
  ({
    input: { value, placeholder },
    meta: { valid, error },
    options,
    children,
    ...restProps
  }) => (
    <div className={styles.Select}>
      <Select
        {...restProps}
        value={value}
        options={createOptions(options, children)}
        noResultsText="По вашему запросу ничего не найдено"
        placeholder={
          placeholder ||
          restProps.placeholder ||
          `Введите значение для поиска...`
        }
        invalid={!valid}
        className={cn({
          [styles[`red-border`]]: error,
        })}
      />
      <div className={styles[`input-error`]}>{error}</div>
    </div>
  ),
)
